import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { env } from '../environments/environment';
import { LoginResponseDto } from './api/loginResponseDto'
import { UserDataForMetaMaskLoginDto } from './api/userDataForMetaMaskLoginDto';
import { LoginMetaMaskDto } from './api/loginMetaMaskDto';
import { UserDto } from './api/userDto';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	constructor(private http: HttpClient) {}

	login(email: string, pwd: string): Observable<LoginResponseDto> {
		const body = JSON.stringify({ email, pwd });
		return this.http.post<LoginResponseDto>(`${env.beURL}/login`, body);
	}

	loginWithMetaMask(metamaskDto: LoginMetaMaskDto): Observable<LoginResponseDto> {
		const body = JSON.stringify(metamaskDto);
		return this.http.post<LoginResponseDto>(`${env.beURL}/login/metamask`, body);
	}

	getLoginNonce = (address: string): Promise<UserDataForMetaMaskLoginDto> => {
		return this.http.get<UserDataForMetaMaskLoginDto>(env.beURL + '/login/nonce/' + address).toPromise();
	}

	saveProfile(name: string, email: string, wallet: string, newPwd?: string) {
		const body = newPwd ? JSON.stringify({ name, email, wallet, newPwd }) : JSON.stringify({ name, email, wallet });
		return this.http.put(`${env.beURL}/me`, body);
	}

	getProfile(): Observable<UserDto> {
		return this.http.get<UserDto>(`${env.beURL}/me`);
	}

	activate(resetKey: string): Observable<LoginResponseDto> {
		return this.http.get<LoginResponseDto>(env.beURL + '/reg/activate/' + resetKey);
	}

	resend(email: string): Observable<any> {
		const body = JSON.stringify({ email });
		return this.http.post(`${env.beURL}/reg/resend`, body);
	}

	register(name: string, email: string, pwd: string, wallet: string) {
		const body = JSON.stringify({ name, email, pwd, wallet, lang: 'en' });
		return this.http.post(`${env.beURL}/reg`, body);
	}
}